<ng-container *ngIf="templateContext$ | async as content">
  <div class="container cart">
    <div class="cart-header">
      <div class="cart-header-title">
        <h1>{{ 'cart.title' | translate }}</h1>
        <p>#{{ content.cart.data?.code }}{{ content.cart.data?.name ? ' - ' + content.cart.data?.name : '' }}</p>
      </div>

      <div class="cart-header-actions">
        <cx-button class="btn-outline" (click)="onSaveCart()" [iconPosition]="'left'" [icon]="'bookmark_star'">{{
          'cart.save' | translate
        }}</cx-button>
        <cx-button (click)="goToCartList()" class="btn-outline" [iconPosition]="'left'" [icon]="'collections_bookmark'">{{
          'cart.load' | translate
        }}</cx-button>
      </div>
    </div>

    <div class="cart-content">
      <div class="cart-content-b2bUnits">
        @if (content.cart.isLoading) {
          <local-loader></local-loader>
        } @else if (content.isEmpty) {
          <p class="no-b2bUnits">{{ 'cart.empty' | translate }}</p>
        } @else {
          <cart-furnisher />
        }
      </div>

      <div class="cart-content-values">
        <cart-coupon />
        <cart-totals
          [cart]="content.cart.data!"
          [buttonText]="'cart.summaryTotals.continueOrder' | translate"
          [insideButton]="true"
          (buttonClick)="goToCartReview()"
          [disableButton]="content.isEmpty"
        />
      </div>
    </div>
  </div>
</ng-container>
